const desktop = window.matchMedia('(min-width: 1024px)');

// Sidebar state for _Layout: collapsible on desktop, an off-canvas drawer below lg.
export default () => ({
  isDesktop: desktop.matches,
  collapsed: false,
  drawerOpen: false,

  init() {
    desktop.addEventListener('change', (event) => {
      this.isDesktop = event.matches;
      this.drawerOpen = false;
    });
  },

  get sidebarOpen() {
    return this.isDesktop ? !this.collapsed : this.drawerOpen;
  },

  toggleSidebar() {
    if (this.isDesktop) {
      this.collapsed = !this.collapsed;
    } else {
      this.drawerOpen = !this.drawerOpen;
    }
  },

  closeDrawer() {
    this.drawerOpen = false;
  },
});
